import { Box } from '@mui/material';
import Grid from '@mui/material/Grid';
import Link from '@mui/material/Link';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useMyMApi from "../../hooks/useMyMApi";
import useWebContext from '../../hooks/useWebContext';
import { MyMImage } from '../../ui-elements/MyMImage';
import { MyMLabel, MyMVariantLabel } from '../../ui-elements/MyMLabel';
/* 必要になった際にはコメントアウトを解除する*/
//import { MyMBlackLink } from '../../ui-elements/MyMLink';
//import { MyMTooltip } from '../../ui-elements/MyMToolTip';
import { MyMProgress } from '../../ui-elements/MyMProgress';
import { mediaQuery, useMediaQuery } from '../../hooks/useMediaQuery';
import { MyMModal } from '../../ui-elements/MyMModal';
import { MyMLink } from '../../ui-elements/MyMLink';
import Card from '@mui/material/Card';

/** MyMine Version12.0 DigitalSolutionLv1画面新規追加
* DigitalSolutionLv1 Page Content
*/
export const DigitalSolutionLv1 = () => {
  const PartnerWebsiteLogo = (props) => {
    /* 必要になった際にはコメントアウトを解除する*/
    //const { index, xs, backgroundColor, url, filePath } = props;
    const { index, xs } = props;
    return (
      <Grid item key={index} xs={xs}
        sx={{
          margin: '2px',
          /* 必要になった際にはコメントアウトを解除する*/
          //backgroundColor: backgroundColor,
          //border: 3,
          height: '40px',
          //border: 3,
          border: 0,
          borderColor: 'gray',
          borderRadius: '5px'
        }}>
        {/* 必要になった際にはコメントアウトを解除する*/}
        {/*  <Link target="_blank" href={url}>*/}
        {/*    <Box sx={{*/}
        {/*      width: '100%',*/}
        {/*      height: '40px',*/}
        {/*      display: 'flex',*/}
        {/*      alignItems: 'center',*/}
        {/*      justifyContent: 'center'*/}
        {/*    }}>*/}
        {/*      {filePath && <MyMImage screenId={screenId} filePath={filePath} width='80%' height='90%' style={{ objectFit: 'contain' }} />}*/}
        {/*    </Box>*/}
        {/*  </Link>*/}
      </Grid>
    );
  }

  const DigitalSolutionLv2SubLv2OrLv3HeaderLink = (props) => {
    /* 必要になった際にはコメントアウトを解除する*/
    //const { position, label, filePath, style, isImageLeft, url, isFontWeight, title, placement } = props;
    const { position, label, filePath, style, isImageLeft, isFontWeight, isPitSafety } = props;
    return (
      <Box sx={{
        textAlign: position,
      }}>

        <Box
          sx={{
            display: 'inline-block',
            width: 'auto',
            height: '50px',
            ...style
          }}
        >

          {/* 必要になった際にはコメントアウトを解除し、inline-blockが設定されているBoxを削除する*/}
          {/*  <MyMBlackLink*/}
          {/*    onClick={() => navigate(url)}*/}
          {/*    sx={{*/}
          {/*      display: 'inline-block',*/}
          {/*      width: 'auto',*/}
          {/*      height: '50px',*/}
          {/*      padding: '5px',*/}
          {/*      ...style*/}
          {/*    }}*/}
          {/*  >*/}
          {/*    <MyMTooltip title={title} placement={placement}>*/}

          <Box sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}>
            {/* 必要になった際にはコメントアウトを解除する*/}
            {/*  {*/}
            {/*  isImageLeft && */}
            {/*    <MyMImage screenId={screenId} filePath={filePath} width='60px' height='60px' />*/}
            {/*}*/}

            {
              isImageLeft & isPitSafety ?
                <MyMImage screenId={screenId} filePath={filePath} width='60px' height='60px' />
                :
                isImageLeft &&
                <MyMImage screenId={screenId} filePath={filePath} width='50px' height='50px' />
            }

            <MyMLabel
              sx={{
                textAlign: position,
                whiteSpace: 'nowrap',
                ...isFontWeight ? { fontWeight: 'bold' } : {}
              }}
              fontSize='1.5rem'
            >
              {label}
            </MyMLabel>
            {
              !isImageLeft &&
              <MyMImage screenId={screenId} filePath={filePath} width='50px' height='50px' />
            }
          </Box>
          {/* 必要になった際にはコメントアウトを解除する*/}
          {/*    </MyMTooltip>*/}
          {/*  </MyMBlackLink>*/}

        </Box>

      </Box>
    );
  }

  const DigitalSolutionLv3HeaderLink = (props) => {
    const { label, filePath, textAlign, isImageUnder } = props;
    return (
      <Box sx={{
        ...isImageUnder ? {
          marginBottom: '0px'
        } : {},
        ...!isImageUnder ? {
          marginTop: '25px'
        } : {},
      }}>
        <Box sx={{ margin: '0 15px', textAlign: textAlign }}>
          {!isImageUnder && <MyMImage screenId={screenId} filePath={filePath} width='50px' height='50px' />}
          <MyMLabel
            sx={{
              lineHeight: '1',
              marginBottom: '0px',
            }}
            fontSize='1.5rem'
            color="black"
          >
            {label}
          </MyMLabel>
          {isImageUnder && <MyMImage screenId={screenId} filePath={filePath} width='50px' height='50px' />}
        </Box>
      </Box>
    );
  }

  const SolutionHeader = (props) => {
    const { width, label1, label2, top, isLabel2Bold, backgroundColor, label1left, label2right } = props;
    return (
      <>
        <Box sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: backgroundColor,
          color: 'white',
          height: '38.6px',
          width: width,
          pointerEvents: 'none',
          position: 'absolute',
          top: `${top}%`,
          left: '50%',
          transform: 'translate(-50%, -50%)',
          zIndex: '2',
          borderRadius: 1,
        }}>
        </Box>
        <MyMLabel
          fontSize='1.5rem'
          sx={{
            position: 'absolute',
            top: `${top - 2}%`,
            left: label1left,
            zIndex: 100,
            color: 'white'
          }}
        >{label1}</MyMLabel>
        <MyMLabel
          fontSize='1.5rem'
          fontWeight={isLabel2Bold}
          sx={{
            position: 'absolute',
            top: `${top - 2}%`,
            right: label2right,
            zIndex: 100,
            color: 'white'
          }}
        >{label2}</MyMLabel>
      </>
    );
  };
  const screenId = 'MyM309';
  const { controlSettings } = useWebContext(screenId);
  const apiRequest = useMyMApi(screenId);
  const navigate = useNavigate();
  const [isInitLoading, setIsInitLoading] = useState(true);
  const isPc = useMediaQuery(mediaQuery.pc);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleModalClose = () => setIsModalOpen(false);
  const onClickModal = (e) => {
    setIsModalOpen(true);
  }

  useEffect(() => {
    const endLoading = () => setIsInitLoading(false);
    apiRequest.requestJson('api/digital-solution/lv1', 'GET', endLoading, endLoading);
  }, [])

  if (isInitLoading)
    return <MyMProgress />

  return (
    <Box className='py-1'>
      <Box>
        <MyMVariantLabel variant='h5'>{controlSettings.LabelList.lblDigitalSolutionLv1Title}</MyMVariantLabel>
        <MyMLabel>{controlSettings.LabelList.lblDigitalSolutionLv1Massage}</MyMLabel>
      </Box>

      {isPc ?

        <Box sx={{
          position: 'relative',
          width: '1500px',
          height: '777px',
          ml: 'auto',
          mr: 'auto',
          mt: '30px'
        }}>
          {/*PC*/}
          <SolutionHeader label1={controlSettings.LabelList.lblSolutionForSite} label2={controlSettings.LabelList.lblSolutionForSite2} width='80%' top='2' backgroundColor='#B8B8B8' label1left='10.5%' label2right='10.5%' />
          <Box sx={{
            position: 'absolute',
            top: '8.5%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            zIndex: '1'
          }}>
            <MyMImage screenId={screenId} filePath={controlSettings.ImageList.imgUpArrow1} width='55px' height='55px' />
          </Box>
          <SolutionHeader label1={controlSettings.LabelList.lblSolutionForPit} label2={controlSettings.LabelList.lblSolutionForPit2} width='64%' top='13.5' backgroundColor='#999999' label1left='19%' label2right='19%' />
          <Box sx={{
            position: 'absolute',
            top: '19.8%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            zIndex: '2',
          }}>
            <MyMImage screenId={screenId} filePath={controlSettings.ImageList.imgUpArrow2} width='55px' height='55px' />
          </Box>
          <SolutionHeader label1={controlSettings.LabelList.lblSolutionForHcmMachines} label2={controlSettings.LabelList.lblSolutionForHcmMachines2} width='48.5%' top='25.5' backgroundColor='#747474' label1left='27%' label2right='27%' />

          {/*OpenAutonomyPanel*/}
          <Box sx={{
            backgroundColor: '#FEE4CE',
            height: '36.7%',
            width: '32%',
            position: 'absolute',
            bottom: '50%',
            right: '50%',
            zIndex: '1',
          }}>
            <DigitalSolutionLv2SubLv2OrLv3HeaderLink
              position='left'
              filePath={controlSettings.ImageList.imgOpenAutonomyLogo}
              label={controlSettings.LabelList.lblOpenAutonomy}
              style={{
                marginLeft: "15px",
                marginTop: "25px"
              }}
              isImageLeft={true}
              url={`MyM312/${controlSettings.LabelList.lblOpenAutonomy}`}
              title={controlSettings.LabelList.lblOpenAutonomyTooltip}
              placement='right'
            />
            <Grid container sx={{
              width: "40.5%",
              position: 'absolute',
              bottom: '0',
              marginLeft: '1.5%',
              marginBottom: '1.85%'
            }}>
              {[...Array(9)].map((_, index) => (
                <PartnerWebsiteLogo
                  index={index}
                  key={index}
                  backgroundColor='#FCD5B5'
                  xs={3.5}
                  url={controlSettings.UrlList['urlOpenAutonomyPartnerWebsiteLogo' + (index + 1)]}
                  filePath={controlSettings.ImageList['imgOpenAutonomyPartnerWebsiteLogo' + (index + 1)]}
                />
              ))}
            </Grid>
          </Box>

          {/*AssetHealthForPitPanel*/}
          <Box sx={{
            backgroundColor: '#E4EDD3',
            height: '36.7%',
            width: '32%',
            position: 'absolute',
            bottom: '50%',
            left: '50%',
            zIndex: '1',
          }}>
            <DigitalSolutionLv2SubLv2OrLv3HeaderLink
              position='right'
              filePath={controlSettings.ImageList.imgAssetHealthForPitLogo}
              label={controlSettings.LabelList.lblAssetHealthForPit}
              style={{
                marginRight: "15px",
                marginTop: "25px",
              }}
              isImageLeft={false}
              url={`MyM312/${controlSettings.LabelList.lblAssetHealthForPit}`}
              title={controlSettings.LabelList.lblAssetHealthForPitTooltip}
              placement='left'
            />

            <Grid container sx={{
              width: "40.5%",
              position: 'absolute',
              bottom: '0',
              right: '0',
              marginBottom: '1.85%',
              marginRight: '1.5%',
              justifyContent: 'flex-end'
            }}>
              {[...Array(9)].map((_, index) => (
                <PartnerWebsiteLogo
                  index={index}
                  key={index}
                  backgroundColor='#D7E4BD'
                  xs={3.5}
                  url={controlSettings.UrlList['urlAssetHealthForPitPartnerWebsiteLogo' + (index + 1)]}
                  filePath={controlSettings.ImageList['imgAssetHealthForPitPartnerWebsiteLogo' + (index + 1)]}
                />
              ))}
            </Grid>
          </Box>

          {/*PitSafetyPanel*/}
          <Box sx={{
            backgroundColor: '#D8CFE3',
            height: '36.7%',
            width: '32%',
            borderBottomLeftRadius: '40px',
            position: 'absolute',
            top: '50%',
            right: '50%',
            zIndex: '1',
          }}>
            <Grid container sx={{
              width: "40.5%",
              position: 'absolute',
              marginLeft: '1.5%',
              marginTop: '1.85%'
            }}>
              {[...Array(9)].map((_, index) => (
                <PartnerWebsiteLogo
                  index={index}
                  key={index}
                  backgroundColor='#CCC1DA'
                  xs={3.5}
                  url={controlSettings.UrlList['urlPitSafetyPartnerWebsiteLogo' + (index + 1)]}
                  filePath={controlSettings.ImageList['imgPitSafetyPartnerWebsiteLogo' + (index + 1)]}
                />
              ))}
            </Grid>
            <DigitalSolutionLv2SubLv2OrLv3HeaderLink
              position='left'
              filePath={controlSettings.ImageList.imgPitSafetyLogo}
              label={controlSettings.LabelList.lblPitSafety}
              style={{
                position: 'absolute',
                marginRight: "10px",
                marginTop: '150px',
                bottom: '3%',
                marginLeft: '15px',
                marginBottom: '5px'
              }}
              isImageLeft={true}
              url={`MyM312/${controlSettings.LabelList.lblPitSafety}`}
              title={controlSettings.LabelList.lblPitSafetyTooltip}
              placement='right'
              isPitSafety={true}
            />
          </Box>
          {/*EsgPitOptimizationPanel*/}
          <Box sx={{
            backgroundColor: '#CFEAF1',
            height: '36.7%',
            width: '32%',
            borderBottomRightRadius: '40px',
            position: 'absolute',
            top: '50%',
            left: '50%',
            zIndex: '1',
          }}>
            <Grid container sx={{
              width: "40.5%",
              position: 'absolute',
              marginRight: '1.5%',
              marginTop: '1.85%',
              right: '0',
              justifyContent: 'flex-end'

            }}>
              {[...Array(9)].map((_, index) => (
                <PartnerWebsiteLogo
                  index={index}
                  key={index}
                  backgroundColor='#B7DEE8'
                  xs={3.5}
                  url={controlSettings.UrlList['urlEsgPitOptimizationPartnerWebsiteLogo' + (index + 1)]}
                  filePath={controlSettings.ImageList['imgEsgPitOptimizationPartnerWebsiteLogo' + (index + 1)]}
                />
              ))}
            </Grid>
            <DigitalSolutionLv2SubLv2OrLv3HeaderLink
              position='right'
              filePath={controlSettings.ImageList.imgEsgPitOptimizationLogo}
              label={controlSettings.LabelList.lblEsgPitOptimization}
              style={{
                position: 'absolute',
                marginRight: "10px",
                marginTop: '150px',
                bottom: '0',
                right: '0',
                marginBottom: '10px'
              }}
              isImageLeft={false}
              url={`MyM311/${controlSettings.LabelList.lblEsgPitOptimization}`}
              title={controlSettings.LabelList.lblEsgPitOptimizationTooltip}
              placement='left'
            />
          </Box>

          <Box
            sx={{
              position: 'absolute',
              top: '25.5%',
              left: '25.7%',
              zIndex: '1',
              height: '49%',
              width: '48.5%',
              borderRadius: '40px',
              '&:hover': {
                boxShadow: '0 4px 20px 5px rgba(0,0,0,0.4)',
                textDecoration: 'underline',
              }
            }}
          >
            <Link
              onClick={() => navigate(`MyM310/${controlSettings.LabelList.lblSolutionForHcmMachines}`)}
              sx={{ '&:hover': { cursor: 'pointer' } }}
            >
              {/*ProductivityImprovementPanel*/}
              <Box
                sx={{
                  height: '50%',
                  width: '50%',
                  position: 'absolute',
                  bottom: '50%',
                  right: '50%',
                  backgroundColor: '#FCD5B5',
                  zIndex: '1',
                }}
              >
                <Box
                  sx={{
                    position: 'absolute',
                    bottom: '43%',
                    left: '2%'
                  }}
                >
                  <DigitalSolutionLv3HeaderLink
                    label={controlSettings.LabelList.lblProductivityImprovement}
                    filePath={controlSettings.ImageList.imgProductivityImprovementLogo}
                    textAlign='left'
                    isImageUnder={true}
                    isFontWeight={true}
                  />
                </Box>
              </Box>

              {/*LccReductionPanel*/}
              <Box
                sx={{
                  height: '50%',
                  width: '50%',
                  position: 'absolute',
                  bottom: '50%',
                  left: '50%',
                  backgroundColor: '#CCDDAB',

                  zIndex: '1',
                }}
              >
                <Box
                  sx={{
                    position: 'absolute',
                    bottom: '43%',
                    left: '47%',
                  }}
                >
                  <DigitalSolutionLv3HeaderLink
                    label={controlSettings.LabelList.lblLccReduction}
                    filePath={controlSettings.ImageList.imgLccReductionLogo}
                    textAlign='right'
                    isImageUnder={true}
                    isFontWeight={true}
                  />
                </Box>
              </Box>

              {/*SafetyImprovementPanel*/}
              <Box
                sx={{
                  backgroundColor: '#C8BED4',
                  height: '50%',
                  width: '50%',
                  borderBottomLeftRadius: '40px',
                  position: 'absolute',
                  top: '50%',
                  right: '50%',
                  zIndex: '1',
                }}
              >
                <Box
                  sx={{
                    position: 'absolute',
                    top: '33%',
                    left: '2%'
                  }}
                >
                  <DigitalSolutionLv3HeaderLink
                    label={controlSettings.LabelList.lblSafetyImprovement}
                    filePath={controlSettings.ImageList.imgSafetyImprovementLogo}
                    textAlign='left'
                    isImageUnder={false}
                    isFontWeight={true}
                  />
                </Box>
              </Box>

              {/*EsgContributionsPanel*/}
              <Box
                sx={{
                  backgroundColor: '#B0DAE6',
                  height: '50%',
                  width: '50%',
                  borderBottomRightRadius: '40px',
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  zIndex: '1',
                }}
              >
                <Box
                  sx={{
                    position: 'absolute',
                    top: '33%',
                    left: '35%',
                  }}
                >
                  <DigitalSolutionLv3HeaderLink
                    label={controlSettings.LabelList.lblEsgContributions}
                    filePath={controlSettings.ImageList.imgEsgContributionsLogo}
                    textAlign='right'
                    isImageUnder={false}
                    isFontWeight={true}
                  />
                </Box>
              </Box>

              {/*RemoteMonitoringCoCreationPanel*/}
              <MyMLabel
                component='span'
                sx={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  borderRadius: '10px',
                  height: '65%',
                  width: '70%',
                  backgroundColor: '#FFFFFF',
                  zIndex: '100',
                  color: 'white'
                }}          >
                <Box
                  sx={{
                    position: 'relative',
                    top: '10%',
                  }}
                >
                  <MyMImage
                    screenId={screenId}
                    filePath={controlSettings.ImageList.imgRemoteMonitoringCoCreationLogo}
                    height='80%'
                    width='100%'
                    style={{ objectFit: 'contain' }}
                  />
                  <MyMLabel color='black' fontSize='1.5rem'
                    sx={{ lineHeight: '1', position: 'relative', left: '17%' }}>
                    {controlSettings.LabelList.lblRemoteMonitoringCoCreation}</MyMLabel>
                </Box>
              </MyMLabel>

            </Link>
          </Box>

          <Box sx={{ height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Box sx={{ width: '80%', height: '96%', position: 'relative' }}>
              <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: '100%', height: '100%' }}>
                <Box sx={{
                  display: 'flex',
                  height: '50%',
                }}>
                  {/*ProductivitySiteOptimizationPanel*/}
                  <Box sx={{
                    backgroundColor: '#FEF4EC',
                    height: '100% ',
                    width: '100%',
                    position: 'relative',
                  }}>
                    <DigitalSolutionLv2SubLv2OrLv3HeaderLink
                      position='left'
                      filePath={controlSettings.ImageList.imgProductivitySiteOptimizationLogo}
                      label={controlSettings.LabelList.lblProductivitySiteOptimization}
                      style={{
                        marginLeft: "10px",
                        marginTop: "20px"
                      }}
                      isImageLeft={true}
                      url={`MyM312/${controlSettings.LabelList.lblProductivitySiteOptimization}`}
                      title={controlSettings.LabelList.lblProductivitySiteOptimizationTooltip}
                      placement='right'
                    />
                    <Grid container sx={{
                      width: "28%",
                      position: 'absolute',
                      bottom: '0',
                      marginLeft: '1.5%',
                      marginBottom: '1.5%'
                    }}>
                      {[...Array(6)].map((_, index) => (
                        <PartnerWebsiteLogo
                          index={index}
                          key={index}
                          backgroundColor='#FDEADA'
                          xs={5}
                          url={controlSettings.UrlList['urlProductivitySiteOptimizationPartnerWebsiteLogo' + (index + 1)]}
                          filePath={controlSettings.ImageList['imgProductivitySiteOptimizationPartnerWebsiteLogo' + (index + 1)]}
                        />
                      ))}
                    </Grid>
                  </Box>

                  {/*AssetHealthForSitePanel*/}
                  <Box sx={{
                    backgroundColor: '#F4F7ED',
                    height: '100% ',
                    width: '100%',
                    position: 'relative',
                  }}>
                    <DigitalSolutionLv2SubLv2OrLv3HeaderLink
                      position='right'
                      filePath={controlSettings.ImageList.imgAssetHealthForSiteLogo}
                      label={controlSettings.LabelList.lblAssetHealthForSite}
                      style={{
                        marginRight: "10px",
                        marginTop: "20px",
                      }}
                      isImageLeft={false}
                      url={`MyM312/${controlSettings.LabelList.lblAssetHealthForSite}`}
                      title={controlSettings.LabelList.lblAssetHealthForSiteTooltip}
                      placement='left'
                    />
                    <Grid container sx={{
                      width: "28%",
                      position: 'absolute',
                      bottom: '0',
                      right: '0',
                      marginRight: '1.5%',
                      marginBottom: '1.5%',
                      justifyContent: 'flex-end'
                    }}>
                      {[...Array(6)].map((_, index) => (
                        <PartnerWebsiteLogo
                          index={index}
                          key={index}
                          backgroundColor='#EBF1DE'
                          xs={5}
                          url={controlSettings.UrlList['urlAssetHealthForSitePartnerWebsiteLogo' + (index + 1)]}
                          filePath={controlSettings.ImageList['imgAssetHealthForSitePartnerWebsiteLogo' + (index + 1)]}
                        />
                      ))}
                    </Grid>
                  </Box>
                </Box>

                <Box sx={{
                  display: 'flex',
                  height: '50%'
                }}>
                  {/*SiteSafetyPanel*/}
                  <Box sx={{
                    backgroundColor: '#ECE7F1',
                    height: '100% ',
                    width: '100%',
                    borderBottomLeftRadius: '40px',
                    position: 'relative',
                  }}>
                    <Grid container sx={{
                      width: "28%",
                      position: 'absolute',
                      marginLeft: '1.5%',
                      marginTop: '1.5%',
                    }}>
                      {[...Array(6)].map((_, index) => (
                        <PartnerWebsiteLogo
                          index={index}
                          key={index}
                          backgroundColor='#E6E0EC'
                          xs={5}
                          url={controlSettings.UrlList['urlSiteSafetyPartnerWebsiteLogo' + (index + 1)]}
                          filePath={controlSettings.ImageList['imgSiteSafetyPartnerWebsiteLogo' + (index + 1)]}
                        />
                      ))}
                    </Grid>
                    <DigitalSolutionLv2SubLv2OrLv3HeaderLink
                      position='left'
                      filePath={controlSettings.ImageList.imgSiteSafetyLogo}
                      label={controlSettings.LabelList.lblSiteSafety}
                      style={{
                        position: 'absolute',
                        marginRight: "10px",
                        marginTop: '150px',
                        bottom: '0',
                        marginLeft: '20px',
                        marginBottom: '10px'
                      }}
                      isImageLeft={true}
                      url={`MyM312/${controlSettings.LabelList.lblSiteSafety}`}
                      title={controlSettings.LabelList.lblSiteSafetyTooltip}
                      placement='right'
                    />
                  </Box>

                  {/*EsgSiteOptimizationPanel*/}
                  <Box sx={{
                    backgroundColor: '#E5F3F7',
                    height: '100% ',
                    width: '100%',
                    borderBottomRightRadius: '40px',
                    position: 'relative',
                  }}>
                    <Grid container sx={{
                      width: "28%",
                      position: 'absolute',
                      right: '0',
                      marginRight: '1.5%',
                      marginTop: '1.5%',
                      justifyContent: 'flex-end'
                    }}>
                      {[...Array(6)].map((_, index) => (
                        <PartnerWebsiteLogo
                          index={index}
                          key={index}
                          backgroundColor='#DBEEF4'
                          xs={5}
                          url={controlSettings.UrlList['urlEsgSiteOptimizationPartnerWebsiteLogo' + (index + 1)]}
                          filePath={controlSettings.ImageList['imgEsgSiteOptimizationPartnerWebsiteLogo' + (index + 1)]}
                        />
                      ))}
                    </Grid>
                    <DigitalSolutionLv2SubLv2OrLv3HeaderLink
                      position='right'
                      filePath={controlSettings.ImageList.imgEsgSiteOptimizationLogo}
                      label={controlSettings.LabelList.lblEsgSiteOptimization}
                      style={{
                        position: 'absolute',
                        marginRight: "10px",
                        marginTop: '150px',
                        bottom: '0',
                        right: '0',
                        marginBottom: '10px'
                      }}
                      isImageLeft={false}
                      url={`MyM311/${controlSettings.LabelList.lblEsgSiteOptimization}`}
                      title={controlSettings.LabelList.lblEsgSiteOptimizationTooltip}
                      placement='left'
                    />
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box >

        :
        <>
          {/*Mobile*/}
          <MyMLink
            onClick={onClickModal}
          >
            <MyMImage screenId={screenId} filePath={controlSettings.ImageList.imgDigitalSolutionLv1Panel} width='100%' height='100%' />
          </MyMLink>
          <Card sx={{ border: '2px solid #D4D4D4', boxShadow: 'none', marginBottom: '10px' }}>
            <Grid container sx={{ padding: '5px' }}>
              <Grid item xs={8}>
                <Link
                  onClick={() => navigate(`MyM310/${controlSettings.LabelList.lblSolutionForHcmMachines}`)}
                  sx={{ '&:hover': { cursor: 'pointer' } }}
                >
                  <MyMLabel fontWeight='bold'>
                    {controlSettings.LabelList.lblSolutionForHcmMachines}
                  </MyMLabel>
                </Link>
              </Grid>
              <Grid item xs={4}>
                <MyMLabel fontWeight='bold' sx={{ position: 'relative', textAlign: 'right' }}>
                  {controlSettings.LabelList.lblSolutionForHcmMachines2}
                </MyMLabel>
              </Grid>
              <Grid item xs={1}>
                <MyMImage screenId={screenId} filePath={controlSettings.ImageList.imgProductivityImprovementLogo} width='25px' height='25px' />
              </Grid>
              <Grid item xs={11}>
                <MyMLabel sx={{ marginTop: '5px' }}>
                  {controlSettings.LabelList.lblProductivityImprovement}
                </MyMLabel>
              </Grid>
              <Grid item xs={1}>
                <MyMImage screenId={screenId} filePath={controlSettings.ImageList.imgLccReductionLogo} width='25px' height='25px' />
              </Grid>
              <Grid item xs={11}>
                <MyMLabel sx={{ marginTop: '5px' }}>
                  {controlSettings.LabelList.lblLccReduction}
                </MyMLabel>
              </Grid>
              <Grid item xs={1}>
                <MyMImage screenId={screenId} filePath={controlSettings.ImageList.imgSafetyImprovementLogo} width='25px' height='25px' />
              </Grid>
              <Grid item xs={11}>
                <MyMLabel sx={{ marginTop: '5px' }}>
                  {controlSettings.LabelList.lblSafetyImprovement}
                </MyMLabel>
              </Grid>
              <Grid item xs={1}>
                <MyMImage screenId={screenId} filePath={controlSettings.ImageList.imgEsgContributionsLogo} width='25px' height='25px' />
              </Grid>
              <Grid item xs={11}>
                <MyMLabel sx={{ marginTop: '5px' }}>
                  {controlSettings.LabelList.lblEsgContributions}
                </MyMLabel>
              </Grid>
            </Grid>
          </Card>
          <Card sx={{ border: '2px solid #D4D4D4', boxShadow: 'none', marginBottom: '10px' }}>
            <Grid container sx={{ padding: '5px' }}>
              <Grid item xs={6}>
                <MyMLabel fontWeight='bold'>
                  {controlSettings.LabelList.lblSolutionForPit}
                </MyMLabel>
              </Grid>
              <Grid item xs={6}>
                <MyMLabel fontWeight='bold' sx={{ position: 'relative', textAlign: 'right' }}>
                  {controlSettings.LabelList.lblSolutionForPit2}
                </MyMLabel>
              </Grid>
              <Grid item xs={1}>
                <MyMImage screenId={screenId} filePath={controlSettings.ImageList.imgOpenAutonomyLogo} width='25px' height='25px' />
              </Grid>
              <Grid item xs={11}>
                <MyMLabel sx={{ marginTop: '5px' }}>
                  {controlSettings.LabelList.lblOpenAutonomy}
                </MyMLabel>
              </Grid>
              <Grid item xs={1}>
                <MyMImage screenId={screenId} filePath={controlSettings.ImageList.imgAssetHealthForPitLogo} width='25px' height='25px' />
              </Grid>
              <Grid item xs={11}>
                <MyMLabel sx={{ marginTop: '5px' }}>
                  {controlSettings.LabelList.lblAssetHealthForPit}
                </MyMLabel>
              </Grid>
              <Grid item xs={1}>
                <MyMImage screenId={screenId} filePath={controlSettings.ImageList.imgPitSafetyLogo} width='25px' height='25px' />
              </Grid>
              <Grid item xs={11}>
                <MyMLabel sx={{ marginTop: '5px' }}>
                  {controlSettings.LabelList.lblPitSafety}
                </MyMLabel>
              </Grid>
              <Grid item xs={1}>
                <MyMImage screenId={screenId} filePath={controlSettings.ImageList.imgEsgPitOptimizationLogo} width='25px' height='25px' />
              </Grid>
              <Grid item xs={11}>
                <MyMLabel sx={{ marginTop: '5px' }}>
                  {controlSettings.LabelList.lblEsgPitOptimization}
                </MyMLabel>
              </Grid>
            </Grid>
          </Card>
          <Card sx={{ border: '2px solid #D4D4D4', boxShadow: 'none', marginBottom: '10px' }}>
            <Grid container sx={{ padding: '5px' }}>
              <Grid item xs={8}>
                <MyMLabel fontWeight='bold'>
                  {controlSettings.LabelList.lblSolutionForSite}
                </MyMLabel>
              </Grid>
              <Grid item xs={4}>
                <MyMLabel fontWeight='bold' sx={{ position: 'relative', textAlign: 'right' }}>
                  {controlSettings.LabelList.lblSolutionForSite2}
                </MyMLabel>
              </Grid>
              <Grid item xs={1}>
                <MyMImage screenId={screenId} filePath={controlSettings.ImageList.imgProductivitySiteOptimizationLogo} width='25px' height='25px' />
              </Grid>
              <Grid item xs={11}>
                <MyMLabel sx={{ marginTop: '5px' }}>
                  {controlSettings.LabelList.lblProductivitySiteOptimization}
                </MyMLabel>
              </Grid>
              <Grid item xs={1}>
                <MyMImage screenId={screenId} filePath={controlSettings.ImageList.imgAssetHealthForSiteLogo} width='25px' height='25px' />
              </Grid>
              <Grid item xs={11}>
                <MyMLabel sx={{ marginTop: '5px' }}>
                  {controlSettings.LabelList.lblAssetHealthForSite}
                </MyMLabel>
              </Grid>
              <Grid item xs={1}>
                <MyMImage screenId={screenId} filePath={controlSettings.ImageList.imgSiteSafetyLogo} width='25px' height='25px' />
              </Grid>
              <Grid item xs={11}>
                <MyMLabel sx={{ marginTop: '5px' }}>
                  {controlSettings.LabelList.lblSiteSafety}
                </MyMLabel>
              </Grid>
              <Grid item xs={1}>
                <MyMImage screenId={screenId} filePath={controlSettings.ImageList.imgEsgSiteOptimizationLogo} width='25px' height='25px' />
              </Grid>
              <Grid item xs={11}>
                <MyMLabel sx={{ marginTop: '5px' }}>
                  {controlSettings.LabelList.lblEsgSiteOptimization}
                </MyMLabel>
              </Grid>
            </Grid>
          </Card>
          <MyMModal
            open={isModalOpen}
            onClose={handleModalClose}
            width='80%'
            height='80%'
          >
            <MyMImage screenId={screenId} filePath={controlSettings.ImageList.imgDigitalSolutionLv1Panel} width='1000px' />
          </MyMModal>
        </>

      }
    </Box>
  );
}

export default DigitalSolutionLv1;